import { extractTheValue } from '../../utils/app-common'
import { Col, Dropdown, Form, Input, InputRef, Menu, Modal, Row, Select, Space } from 'antd'
import { ColumnType } from 'antd/es/table'
import { ColumnsType } from 'antd/lib/table'
import React, { useCallback, useRef, useState } from 'react'
import { AiOutlineEdit } from 'react-icons/ai'
import { filterFunction } from '../../common/SearchFilterComponent'
import { emailValidation, numericFieldWithCommaValidation, requiredValidation } from '../../validation/validation'
import TableComponent from '../CommonComponent/TableComponent'

type Props = {}


const data = [
	{
		"imei": "180322000001663",
		"deviceType": "0407",
		"emails": [
			"mateen.deshmukh@aj-ex.com"
		],
		"phones": [
			"0540373971"
		]
	},
	{
		"imei": "180322000001660",
		"deviceType": "0407",
		"emails": [
			"sample@ajex.com"
		],
		"phones": [
			"23423423"
		]
	},
	{
		"imei": "861234567891234",
		"deviceType": "0406"
	},
	{
		"imei": "test",
		"deviceType": "0407",
		"emails": [
			"zhisen.li@aj-ex.com"
		],
		"phones": [
			"15707977233"
		],
		"deviceLocation": "warehouse"
	},
	{
		"imei": "699999999999912",
		"deviceType": "0407"
	},
	{
		"imei": "861065040028970",
		"deviceType": "0406"
	}
]
export type IConfiguration = {
	imei: number,
	deviceType: number
}


export type INewConfig = {
	emails: string[],
	phones: string[],
	imei: string,
	deviceType: string
}

const MenuListComponent = ({ row }: { row: IConfiguration }) => {

	const [isConfigModal, setIsConfigModal] = useState(false);

	const [form] = Form.useForm()
	const onEditHandler = useCallback(
		(row: IConfiguration) => {
			setIsConfigModal(true)
		}, [])


	const items = [
		{
			key: 1,
			icon: <AiOutlineEdit size={18} />,
			label: 'Edit',
			onClick: () => onEditHandler(row)
		},
	];

	const onFinishHandler = useCallback((values: INewConfig) => {
		const request: INewConfig = {
			// (values?.emails?.toString())?.replace(/\s+/g, '')?.split(','),
			//
			emails: extractTheValue(values?.emails?.toString()),
			phones: extractTheValue(values?.phones?.toString()),
			imei: values?.imei,
			deviceType: "string"
		};
		;
	}, [])
	const onCancelHandler = useCallback(() => {
		setIsConfigModal(false);
		form.resetFields()
	}, [form])

	return (
		<>
			<Menu
				items={items}
			/>
			<Modal open={isConfigModal} onOk={form.submit} okText='Save' onCancel={onCancelHandler} width={800} title='Add New Configuration'>
				<>
					<Form form={form} onFinish={onFinishHandler}>
						<Row gutter={20}>
							<Col span={6}>
								<Form.Item name={'imei'} label='IMEI' labelCol={{ span: 24 }}>
									<Select
										showSearch
										allowClear
										filterOption={(input, option) =>
											(option?.children as unknown as string)?.toLocaleLowerCase()?.includes(input?.toLocaleLowerCase())
										}>
										{
											[{ id: 0, name: '' }]?.map((account, index) => (
												<React.Fragment key={account?.id}>
													<Select.Option key={account?.id} value={account?.id}>{account?.name}</Select.Option>
												</React.Fragment>
											))
										}
									</Select>
								</Form.Item>
							</Col>
							<Col span={8}>
								<Form.Item name={'phones'} label='Phone Number' rules={[numericFieldWithCommaValidation, requiredValidation]} labelCol={{ span: 24 }}>
									<Input.TextArea cols={8} rows={4} placeholder='Phone Number' />
								</Form.Item>

							</Col>
							<Col span={8}>
								<Form.Item name={'emails'} label='Email' rules={emailValidation} labelCol={{ span: 24 }}>
									<Input.TextArea cols={8} rows={4} placeholder='Email Address' />
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</>
			</Modal>
		</>

	)
}

export default function DeviceConfigComponent({ }: Props) {

	const searchInput = useRef<InputRef>(null);

	const getColumnSearchProps = (dataIndex: string): ColumnType<IConfiguration> => filterFunction(dataIndex, searchInput);

	const columns: ColumnsType<IConfiguration> = [
		{
			title: 'IMEI',
			width: 50,
			dataIndex: 'imei',
			key: 'imei',
			...getColumnSearchProps('imei')
		}, {
			title: 'Device Type',
			width: 50,
			dataIndex: 'deviceType',
			key: 'deviceType',
			...getColumnSearchProps('deviceType')
		},
		{
			title: 'Action',
			key: 'action',
			width: 50,
			render: (row: IConfiguration) => {
				return (
					<>
						<Space size="middle">
							<Dropdown.Button overlay={<MenuListComponent row={row} />}>
							</Dropdown.Button>
						</Space>
					</>
				)
			}
		}
	]
	return (
		<>
			<TableComponent data={data} columns={columns} isLoading={false} rowKey='imei' scroll={{ x: 0, y: 0 }} />
		</>
	)
}